import { Suspense, lazy } from "react";
import { Navigate } from "react-router-dom";

//import SidebarLayout from "src/layouts/SidebarLayout";
//import BaseLayout from "src/layouts/BaseLayout";
import AntLayout from "src/layouts/AntLayout";

import SuspenseLoader from "src/components/SuspenseLoader";
//import LoggedArea from "./utils/LoggedArea";
//import AdminArea from "./utils/AdminArea";

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

//Auth
//const Login = Loader(lazy(() => import("src/pages/auth/Login")));
//const Logout = Loader(lazy(() => import("src/pages/auth/Logout")));
// Pages
//const LandingPage = Loader(lazy(() => import("src/pages/landingpage")));
const AntLandingPage = Loader(lazy(() => import("src/pages/ant_landingpage")));
// const PalapaLanding = Loader(lazy(() => import("src/pages/palapalanding")));
const Palapa = Loader(
  lazy(() => import("src/pages/ant_landingpage/Tools/Palapa"))
);
const AntWebmap = Loader(
  lazy(() => import("src/pages/ant_landingpage/Webmap"))
);
const AntTools = Loader(lazy(() => import("src/pages/ant_landingpage/Tools")));
const AntStunting = Loader(
  lazy(() => import("src/pages/ant_landingpage/Webmap/Stunting"))
);
const AntUnduh = Loader(lazy(() => import("src/pages/ant_landingpage/Unduh")));
const AntBantuan = Loader(
  lazy(() => import("src/pages/ant_landingpage/Bantuan"))
);

const AntKontak = Loader(
  lazy(() => import("src/pages/ant_landingpage/Kontak"))
);
const Batnas = Loader(
  lazy(() => import("src/pages/ant_landingpage/Unduh/Batnas"))
);

const Demnas = Loader(
  lazy(() => import("src/pages/ant_landingpage/Unduh/Demnas"))
);

const RbiWilayah = Loader(
  lazy(() => import("src/pages/ant_landingpage/Unduh/RbiWilayah"))
);

const RbiSumatra = Loader(
  lazy(() => import("src/pages/ant_landingpage/Unduh/RbiSumatra"))
);

const BanjirSumatra = Loader(
  lazy(() => import("src/pages/ant_landingpage/Unduh/BanjirSumatra"))
);

const RbiCetak25K = Loader(
  lazy(() => import("src/pages/ant_landingpage/Unduh/RbiCetak25K"))
);
const RbiCetak50K = Loader(
  lazy(() => import("src/pages/ant_landingpage/Unduh/RbiCetak50K"))
);
const RbiCetak250K = Loader(
  lazy(() => import("src/pages/ant_landingpage/Unduh/RbiCetak250K"))
);

const AntLogin = Loader(lazy(() => import("src/pages/ant_landingpage/Login")));
const AntLogout = Loader(
  lazy(() => import("src/pages/ant_landingpage/Logout"))
);

const AntDaftar = Loader(
  lazy(() => import("src/pages/ant_landingpage/Daftar"))
);
const AntForgot = Loader(
  lazy(() => import("src/pages/ant_landingpage/Forgot"))
);

//const Daftar = Loader(lazy(() => import("src/pages/landingpage/Daftar")));
//const Aktivasi = Loader(lazy(() => import("src/pages/landingpage/Aktivasi")));
//const Unduh = Loader(lazy(() => import("src/pages/landingpage/Unduh")));

// Status

const Status404 = Loader(
  lazy(() => import("src/pages/landingpage/Status/Status404"))
);
const Status500 = Loader(
  lazy(() => import("src/pages/landingpage/Status/Status500"))
);
const StatusComingSoon = Loader(
  lazy(() => import("src/pages/landingpage/Status/ComingSoon"))
);
const StatusMaintenance = Loader(
  lazy(() => import("src/pages/landingpage/Status/Maintenance"))
);

const Overview = Loader(lazy(() => import("src/pages/overview")));

// Dashboards
//const Aktivitas = Loader(lazy(() => import("src/pages/dashboards/Aktivitas")));
//const Notifikasi = Loader(
//  lazy(() => import("src/pages/dashboards/Notifikasi"))
//);

// Systems
//const UserRole = Loader(lazy(() => import("src/pages/systems/User/Role")));
//const UserList = Loader(lazy(() => import("src/pages/systems/User/List")));
const User = Loader(lazy(() => import("src/pages/master/User")));

//const UserForm = Loader(lazy(() => import("src/pages/systems/User/UserForm")));

const Settings = Loader(lazy(() => import("src/pages/systems/Settings")));

// Akun
const UserProfile = Loader(lazy(() => import("src/pages/akun/profile")));
const UserSettings = Loader(lazy(() => import("src/pages/akun/settings")));

// Managements
//const Unit = Loader(lazy(() => import("src/pages/managements/Unit")));

// data
const routes = [
  {
    path: "",
    element: <AntLayout />, //<BaseLayout />,
    children: [
      {
        path: "/",
        element: <AntLandingPage />,
      },
      /* {
        path: "auth",
        children: [
          {
            path: "",
            element: <Navigate to="login" replace />,
          },
          {
            path: "login",
            element: <Login />,
          },
          {
            path: "logout",
            element: <Logout />,
          },
        ],
      },
      */
      {
        path: "daftar",
        element: <AntDaftar />,
      },
      {
        path: "webmap",
        element: <AntWebmap />,
      },
      {
        path: "tools",
        children: [
          {
            path: "",
            element: <AntTools />,
          },
          {
            path: "palapa",
            element: <Palapa />,
          },
        ],
      },
      {
        path: "stunting",
        element: <AntStunting />,
      },
      {
        path: "lupa-password",
        element: <AntForgot />,
      },
      {
        path: "login",
        element: <AntLogin />,
      },
      {
        path: "logout",
        element: <AntLogout />,
      },
      {
        path: "bantuan",
        element: <AntBantuan />,
      },
      {
        path: "kontak",
        element: <AntKontak />,
      },

      {
        path: "unduh",
        children: [
          {
            path: "",
            element: <AntUnduh />,
          },
          {
            path: "batnas",
            element: <Batnas />,
          },
          {
            path: "demnas",
            element: <Demnas />,
          },
          {
            path: "rbi-wilayah",
            element: <RbiWilayah />,
          },
          {
            path: "rbi-sumatra",
            element: <RbiSumatra />,
          },
          {
            path: "banjir-sumatra",
            element: <BanjirSumatra />,
          },
          {
            path: "rbi-cetak-25k",
            element: <RbiCetak25K />,
          },
          {
            path: "rbi-cetak-50k",
            element: <RbiCetak50K />,
          },
          {
            path: "rbi-cetak-250k",
            element: <RbiCetak250K />,
          },
        ],
      },
      {
        path: "status",
        children: [
          {
            path: "",
            element: <Navigate to="404" replace />,
          },
          {
            path: "404",
            element: <Status404 />,
          },
          {
            path: "500",
            element: <Status500 />,
          },
          {
            path: "maintenance",
            element: <StatusMaintenance />,
          },
          {
            path: "coming-soon",
            element: <StatusComingSoon />,
          },
        ],
      },
      {
        path: "*",
        element: <Status404 />,
      },
    ],
  },
  /*
  {
    path: "mui",
    element: <BaseLayout />,
    children: [
      {
        path: "",
        element: <LandingPage />,
      },
    ],
  },
  
  {
    path: "dashboard",
    element: (
      <LoggedArea>
        <SidebarLayout />
      </LoggedArea>
    ),
    children: [
      {
        path: "",
        element: <Overview />,
      },
    ],
  },

  {
    path: "master",
    element: (
      <LoggedArea>
        <SidebarLayout />
      </LoggedArea>
    ),
    children: [
      {
        path: "",
        element: <Navigate to="role" replace />,
      },
      {
        path: "role",
        element: (
          <AdminArea>
            <User />
          </AdminArea>
        ),
      },

      /*
      {
        path: "user",
        children: [
          {
            path: "",
            element: <Navigate to="role" replace />,
          },
          {
            path: "role",
            element: <User tab="role" />,
          },
          {
            path: "list",
            element: <User tab="list" />,
          },
          {
            path: "add",
            element: <UserForm title="Add User" caption="Penambahan User" />,
          },
        ],
      },
      /
    ],
  },
  {
    path: "akun",
    element: (
      <LoggedArea>
        <SidebarLayout />
      </LoggedArea>
    ),
    children: [
      {
        path: "",
        element: <Navigate to="profile" replace />,
      },
      {
        path: "profile",
        children: [
          {
            path: "",
            element: <Navigate to="details" replace />,
          },
          {
            path: "details",
            element: <UserProfile />,
          },
          {
            path: "settings",
            element: <UserSettings />,
          },
        ],
      },
    ],
  },
  /*
  {
    path: "dashboards",
    element: (
      <LoggedArea>
        <SidebarLayout />
      </LoggedArea>
    ),
    children: [
      {
        path: "",
        element: <Navigate to="aktivitas" replace />,
      },
      {
        path: "aktivitas",
        element: <Aktivitas />,
      },
      {
        path: "notifikasi",
        element: <Notifikasi />,
      },
    ],
  },
  
  {
    path: "managements",
    element: (
      <LoggedArea>
        <SidebarLayout />
      </LoggedArea>
    ),
    children: [
      {
        path: "",
        element: <Navigate to="akuntansi" replace />,
      },
      {
        path: "akuntansi",
        element: <Akuntansi />,
      },
      {
        path: "anggota",
        element: <Anggota />,
      },
      {
        path: "simpanan",
        element: <Simpanan />,
      },
      {
        path: "pinjaman",
        element: <Pinjaman />,
      },
      {
        path: "saldo-akun",
        element: <Saldo_akun />,
      },
    ],
  },
  {
    path: "laporan",
    element: (
      <LoggedArea>
        <SidebarLayout />
      </LoggedArea>
    ),
    children: [
      {
        path: "",
        element: <Navigate to="neraca" replace />,
      },
      {
        path: "neraca",
        element: <Neraca />,
      },
      {
        path: "laba-rugi",
        element: <LabaRugi />,
      },
      {
        path: "arus-kas",
        element: <ArusKas />,
      },
    ],
  },
  {
    path: "transaksi",
    element: (
      <LoggedArea>
        <SidebarLayout />
      </LoggedArea>
    ),
    children: [
      {
        path: "",
        element: <Navigate to="simpanan" replace />,
      },
      {
        path: "simpanan",
        element: <TSimpanan />,
      },
      {
        path: "pinjaman",
        element: <TPinjaman />,
      },
      {
        path: "kas",
        element: <TKas />,
      },
    ],
  },
  */
];

export default routes;
